import { useEffect, useState } from "react";

// Порт референсного core/hooks/useLabelsVisibility.js: видимость меток
// (MARKER) на сикбаре. Состояние живёт в localStorage и синхронизируется
// между всеми инстансами хука через CustomEvent.
const STORAGE_KEY = "player-labels-visible";
const EVENT_NAME = "labelsVisibilityChanged";

export function useLabelsVisibility(): [boolean, () => void] {
  const [labelsVisible, setLabelsVisible] = useState(() => {
    // SSR: по умолчанию включены
    if (typeof window === "undefined") return true;

    const stored = window.localStorage.getItem(STORAGE_KEY);
    return stored !== null ? stored === "true" : true;
  });

  const toggleLabelsVisibility = () => {
    const newValue = !labelsVisible;
    setLabelsVisible(newValue);

    if (typeof window !== "undefined") {
      window.localStorage.setItem(STORAGE_KEY, String(newValue));
      window.dispatchEvent(
        new CustomEvent(EVENT_NAME, { detail: { visible: newValue } })
      );
    }
  };

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    const handleChange = (event: Event) => {
      setLabelsVisible(
        Boolean((event as CustomEvent<{ visible: boolean }>).detail.visible)
      );
    };

    window.addEventListener(EVENT_NAME, handleChange);
    return () => window.removeEventListener(EVENT_NAME, handleChange);
  }, []);

  return [labelsVisible, toggleLabelsVisibility];
}
